import { Hero } from "../components/sections/Hero";
import { TrustStrip } from "../components/sections/TrustStrip";
import { HowItWorks } from "../components/sections/HowItWorks";
import { BankCalculator } from "../components/sections/BankCalculator";
import { StreakWidget } from "../components/sections/StreakWidget";
import { LifestyleBand } from "../components/sections/LifestyleBand";
import { PhoneDemo } from "../components/sections/PhoneDemo";
import { Personas } from "../components/sections/Personas";
import { Community } from "../components/sections/Community";
import { FeaturesGrid } from "../components/sections/FeaturesGrid";
import { Science } from "../components/sections/Science";
import { Pricing } from "../components/sections/Pricing";
import { FAQAccordion } from "../components/sections/FAQAccordion";
import { Waitlist } from "../components/sections/Waitlist";
import { ContactSection } from "../components/sections/ContactSection";
import { FinalCTA } from "../components/sections/FinalCTA";
import { useSettings } from "../hooks/useSettings";

export default function Home() {
  const { waitlist_enabled } = useSettings();
  return (
    <>
      <Hero />
      <TrustStrip />
      <HowItWorks />
      <BankCalculator />
      <StreakWidget />
      <LifestyleBand />
      <PhoneDemo />
      <Personas />
      <Community />
      <FeaturesGrid />
      <Science />
      <Pricing />
      <FAQAccordion />
      {waitlist_enabled && <Waitlist />}
      <ContactSection />
      <FinalCTA />
    </>
  );
}
